import { render, staticRenderFns } from "./FavouriteItem.vue?vue&type=template&id=5e71cd3b&scoped=true"
import script from "./FavouriteItem.vue?vue&type=script&lang=js"
export * from "./FavouriteItem.vue?vue&type=script&lang=js"
import style0 from "./FavouriteItem.vue?vue&type=style&index=0&id=5e71cd3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e71cd3b",
  null
  
)

export default component.exports